import { Card } from "../components/ui/card";

export function Logo({ className = "" }) {
  return (
    <span className={`font-display font-semibold tracking-tight ${className}`}>
      <span className="logo-de">DE</span>
      <span className="logo-fine">FINE</span>
      <span className="ml-2 text-primary text-[0.55em] tracking-[0.3em] align-middle">SALONS</span>
    </span>
  );
}

export function PageHeader({ title, subtitle, actions }) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-6">
      <div>
        <h1 className="font-display text-3xl sm:text-4xl font-medium tracking-tight" data-testid="page-title">{title}</h1>
        {subtitle && <p className="text-muted-foreground text-sm mt-1">{subtitle}</p>}
      </div>
      {actions && <div className="flex gap-2 flex-wrap">{actions}</div>}
    </div>
  );
}

export function StatCard({ label, value, sub, icon: Icon, testid }) {
  return (
    <Card className="p-5 bg-card border-border" data-testid={testid}>
      <div className="flex items-start justify-between">
        <div>
          <p className="text-xs uppercase tracking-wider text-muted-foreground">{label}</p>
          <p className="font-display text-3xl font-medium mt-2">{value}</p>
          {sub && <p className="text-xs text-muted-foreground mt-1">{sub}</p>}
        </div>
        {Icon && <div className="h-9 w-9 rounded-sm bg-primary/15 flex items-center justify-center text-primary"><Icon size={18} /></div>}
      </div>
    </Card>
  );
}

export const rupee = (n) => `₹${Number(n || 0).toLocaleString("en-IN", { maximumFractionDigits: 2 })}`;
// Display a stored 24h "HH:MM" as 12-hour AM/PM (e.g. "15:30" -> "3:30 PM"). Storage unchanged.
export const to12h = (hhmm) => {
  const s = String(hhmm || "");
  if (!s.includes(":")) return s;
  let [h, m] = s.split(":");
  h = parseInt(h, 10); m = (m || "").padStart(2, "0");
  if (isNaN(h)) return s;
  const ap = h >= 12 ? "PM" : "AM";
  h = h % 12 || 12;
  return `${h}:${m} ${ap}`;
};
export const fmtMin = (m) => `${Number(m || 0).toLocaleString("en-IN")} min`;
